<template>
    <button class="btn color-button" :style="{background: utils.colorBrightness(color, 25)}">
        <span class="floating-bg" :style="{background: color}"></span>
        <span class="inner">
            <span class="icon">
                <slot name="icon"/>
            </span>
            <span class="label">
                <slot/>
            </span>
        </span>
    </button>
</template>

<script>
import utils from "@/mixins/utils";
export default {
    name: "ColorButton",
    components: {},

    mixins: [utils],

    props: {
        color: {
            type: String,
            default: '#000',
        }
    }
}
</script>

<style lang="scss" scoped>
.color-button{
    position: relative;
    z-index: 0;
    padding: 0;
    border: none;
    color: white;

    &:hover{
        .floating-bg{
            width: 100%;
            border-radius: $btn-border-radius;
        }
    }
}
.floating-bg{
    position: absolute;
    z-index: 1;
    width: 3rem;
    left: 0;
    top: 0;
    bottom: 0;
    border-radius: $btn-border-radius 0 0 $btn-border-radius;
    transition: width .3s;
}
.inner{
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
}

.icon{
    font-size: 1.2rem;
    display: flex;
    width: 3rem;
    flex: 0 0 3rem;
    padding: .6rem 0;
    align-items: center;
    justify-content: center;
    line-height: 1;
}
.label{
    padding: .6rem .6rem .6rem .6rem;
    font-size: 1.1rem;
    font-weight: $font-weight-semibold;
    @media (max-width: 1199px) {
        font-size: 0.7rem;

        @media (max-width: 400px) {
            font-size: 0.5rem;
        }
    }
}
.btn-block{
    .label{
        flex-grow: 1;
        text-align: center;
    }
}
</style>
